<template>
    <div class="page" :style="{'height':isShow ? '100%' : ''}">
		<template v-if="isShow">
			<div class="rotation">
				<div class="dongtu dongtuBg"></div>
				<div class="dongtu-data">{{cunt}}%</div>
				<div class="rotation-data1">流量监测</div>
			</div>
		</template>
		<template  v-if="!isShow">
			<div class="diagonsis-contetn">
				<div class="result-h">
					<div class="jce">
						<img src="@/assets/img/button/icon_yc.png" alt="" class="icon_yc">
						<div class="jce-num">有<span>{{total}}</span>项异常！</div>
						<div class="result">检测结果</div>
					</div>
				</div>
				<div class="el-flex-content">
					<div class="el-flex-items" v-for="(item,index) in dataList" :key="index">
						<div class="itmetop">
							<div class="img1"><img :src="require(`../../assets/img/button/${item.icon}`)" alt=""></div>
							<div class="text">{{ item.name }}</div>
							<div class="img2">
								<img src="@/assets/img/button/icon_zc.png" alt="" v-if="item.state === 1">
								<img src="@/assets/img/button/icon_yc(1).png" alt="" v-if="item.state === 0">
							</div>
							<div class="text2">{{ item.remark }}</div>
							<div class="text3"  @click="changeFalg(item,index)">
								<span>
									{{!item.falg?'展开':"收起"}}
								</span>
								<van-icon :name="!item.falg ? 'arrow-down' : 'arrow-up'" />
							</div>
						</div>
						<div class="jianceShow" v-if="item.falg">
							<div class="text4">{{ item.remarkInfo }}</div>
							<div class="el-btn1" @click="pageChange(item)" v-if="item.state === 0">{{ item.btnName }}</div>
						</div>
					</div>
				</div>
				<!-- <div class="footer">
					<span class="t">无异常仍然无法使用，查看</span>
					<span class="link">解决方案</span>
				</div> -->
				<div class="el-tbn">
						<div class="el-btn" @click="weight">重 新 诊 断</div>
					</div>
			</div>
		</template>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast,Dialog } from 'vant';
export default {
	data(){
		return{
			iccid: localStorage.getItem("iccid"),
			isShow:true,
			cunt:0,
			total:0,
			timer:null,
			simInfo:{},
			dataList:[],
		}
	},
	created(){
		this.init()
	},
	methods:{
		init(){
			this.timer = setInterval(() => {
				if (this.cunt > 99 ) {
					this.isShow = false
					this.timer = null;
					clearInterval(this.timer);
				} else {
					this.cunt ++
				}
			}, 100);
			this.dataList = []
			wxRequest("/sim/new/oneButton", {iccid:this.iccid}, "post").then((res) => {
				if (res.data.code === "200") {
					res.data.data.accountMap.name='账户余额'
					res.data.data.accountMap.btnName='充值余额'
					res.data.data.accountMap.icon = 'icon_yejc.png'
					res.data.data.accountMap.falg= false
					
					res.data.data.authStateMap.name='实名状态'
					res.data.data.authStateMap.btnName='去实名'
					res.data.data.authStateMap.icon='icon_smzt.png'
					res.data.data.authStateMap.falg= false
					
					res.data.data.pkgNextMap.name='套餐到期'
					res.data.data.pkgNextMap.btnName='前往订购'
					res.data.data.pkgNextMap.icon='icon_lljc.png'
					
					// res.data.data.huoDongMap.name='活动余额'
					// if(res.data.data.huoDongMap.state==1){
					// 	res.data.data.huoDongMap.btnName='活动详情'
					// }else {
					// 	res.data.data.huoDongMap.btnName='参与活动'
					// }
					// res.data.data.huoDongMap.icon='icon_hdjc.png'   res.data.data.huoDongMap,
					
					res.data.data.pkgMap.name='在用套餐'
					res.data.data.pkgMap.btnName='前往订购'
					res.data.data.pkgMap.icon='icon_tc.png'
					
					res.data.data.simStateMap.name='卡号状态'
					res.data.data.simStateMap.btnName='订购套餐'
					res.data.data.simStateMap.icon='icon_kztjc.png'
					this.dataList=[res.data.data.accountMap,res.data.data.authStateMap,res.data.data.pkgNextMap,res.data.data.pkgMap,res.data.data.simStateMap]
					this.dataList = this.dataList.sort((a,b)=>{
						return a.state-b.state
					})
					this.total = this.dataList.filter(v=>v.state === 0).length
					clearInterval(this.timer);
					this.isShow = false
				}else{
					Toast.fail(res.data.message);
				}
			})
		},
		changeFalg(data,index){
			this.$set(this.dataList[index],'falg',!data.falg)
			this.$forceUpdate()
		},
		pageChange(data){
			if(data.name === '套餐到期' || data.name === '在用套餐' || data.name === '卡号状态'){
				this.$router.push({
                    path: "/user/recharge",
                    query: {
                      iccid: this.iccid,
                    },
				});
			}else if(data.name === '实名状态'){
				this.realNameRegister();
			}else if(data.name === '账户余额'){
				this.$router.push({
                    path: "/user/balanceRecharge",
				});
			}
			// else if(data.name === '活动余额' && data.state==1){
			// 	this.$router.push({
            //         path: "/user/applySalePkg",
			// 	});
			// }else if(data.name === '活动余额' && data.state==0){
			// 	this.$router.push({
            //         path: "/user/simOpens",
			// 	});
			// }
		},
		weight(){
			this.isShow = true
			this.init()
		},
		realNameRegister() {
			wxRequest("sim/detail", { iccid: this.iccid }, "post").then((res) => {
				if (res.data.code === '200') {
					this.simInfo =  res.data.data
					var simpkg = {
						iccid: this.simInfo.iccid,
					};
					let iccid = this.simInfo.iccid;

					wxRequest("wxAuth/ctcc/auth", simpkg, "post").then((res) => {
						if (res.data.code == 302) {
							Dialog.confirm({
								title: "购买套餐提醒",
								message:  "请点击 确定 购买套餐后，再进行实名激活操作！",
							}).then((action) => {
								if (action == "confirm") {
									this.$router.replace("/user/recharge");
								}
							}).catch(() => {});
						}else if (res.data.code == 200) {
							  Dialog.alert({ title: "提示", message: '当前卡已完成实名操作，无需再次实名！' });
						}else{
						   if(this.simInfo.flowRatePool=='电信'){
							  this.$router.push({
          							path: "/user/ctccAuth",
                                    query: { realNameCard: 1 },
                              });
						   }else if(this.simInfo.flowRatePool=='联通'){
							   window.location.href = "http://10086.sm.iot000.cn/#/user/cuccAuth";
						   }else if(this.simInfo.flowRatePool=='移动'){
							  this.$router.push({
          							path: "/user/cmccAuth",
                                    query: { realNameCard: 1 },
                              });
						   }else if(this.simInfo.flowRatePool=='移动接口'){
							      wxRequest("wxAuth/cmcc/auth",{ iccid:iccid }, "post").then((res) => {
									        if (res.data.code == "200") {
          											window.location.href = res.data.data;
        									} else {
												  Dialog.alert({
           											title: "提示",
           											message: res.data.message,
          										  });
      										}
    							  });
						   }else{
							 window.localStorage.href=this.simInfo.flowRatePool;
						   }
						}
       			});
			}else{
				Toast.fail(res.data.message);
			}
		})
    }
	}
}
</script>
<style lang="less" scoped>
div{
    display: flex;
    flex-grow: 0;
    flex-basis: auto;
    align-items: stretch;
    flex-direction: column;
}
.page{
	background:#F5F6F7;
	padding-bottom:50px;
	.rotation{
		height:100%;
		position: relative;
		background: url('../../assets/img/button/bg_znzd.png') no-repeat center;
		background-size:100%;
		.dongtuBg{
			background: url('../../assets/img/button/1.png') no-repeat center;
			background-size:100%;
			width:240px;
			top: 0;
			bottom:0;
			left:0;
			right:0;
			margin: auto;
			position: absolute;
			height:240px;
		}
		.dongtu-data,.rotation-data1{
			top: 0;
			bottom:0;
			left:0;
			right:0;
			margin: auto;
			width: 100px;
			position: absolute;
			height:225px;
			line-height:225px;
			margin:auto;
			text-align:center;
			font-size:30px;
			color:#FFFFFF;
		}
		.rotation-data1{
			top: 280px;
			font-size:18px;
		}
		@-webkit-keyframes rotation-data {
			from {
				-webkit-transform:rotate(0deg)
			}
			to {
				-webkit-transform:rotate(1turn)
			}
		}
		.dongtu{
			-webkit-transform:rotate(1turn);
			animation:rotation-data 3s linear infinite;
			-moz-animation:rotation-data 3s linear infinite;
			-webkit-animation:rotation-data 3s linear infinite;
			-o-animation:rotation-data 3s linear infinite
		}
	}
	.diagonsis-contetn{
		align-items: center;
		.result-h{
			background: url('../../assets/img/button/bg_znzd1.png') no-repeat top center;
			background-size:100%;
    		z-index: 9;
			width: 100%;
			height:238px;
			.jce{
				background: url('../../assets/img/button/circle.png') no-repeat center;
				width: 138px;
				height: 138px;
				background-size: 100%;
				align-self: center;
				align-items: center;
				margin-top:40px;
				.icon_yc{
					margin-top: 30px;
				}
				.jce-num{
					margin-top: 10px;
    				flex-direction: row;
					font-size: 19px;
					font-weight: 700;
					color: #fff;
					margin-left: 14px;
					span{
						font-size: 19px;
    					color: #ff0;
					}
				}
				.result{
					font-size: 12px;
					font-weight: 400;
					color: #FFE7E3;
					margin-top:12px;
				}
			}
		}
		.el-flex-content{
			display: flex;
			flex-direction: column;
			align-items: center;
			width:95%;
			height: calc(100% - 368px);
			overflow: auto;
			margin-top: 16px;
			.el-flex-items{
				background: #fff;
				padding: 12px 8px;
				margin-bottom: 10px;
				border-radius: 7px;
				width:93%;
				.itmetop{
					flex-direction: row;
    				align-items: center;
					.img1{
						width: 18px;
    					height: 18px;
					}
					.text{
						font-size: 16px;
						font-weight: 400;
						color: #06121e;
						margin-left:12px;
						margin-right: 35px;
					}
					.img2{
						width: 14px;
						height: 14px;
					}
					.text2{
						font-size: 13px;
						font-weight: 400;
						color: #bdc4ce;
						margin-left: 4px;
						flex: 1;
					}
					.text3{
						flex-direction: row;
						span{
							margin-right: 10px;
							font-size: 15px;
							font-weight: 400;
							color: #8c9198;
						}
					}
				}
			}
			.jianceShow{
				border-top: 1px solid #f7f8fa;
				flex-direction: row;
				align-items: center;
				margin-top: 10px;
				padding: 10px 0 0;
				.text4{
					font-size: 14px;
					font-weight: 400;
					color: #bdc4ce;
					flex: 1;
				}
				.el-btn1{
					padding: 6px 8px;
					background: #1c96f6;
					color: #fff;
					border-radius: 7px;
				}
			}
			
		}
	}	
	.el-tbn{
		height: 54px;
		display: flex;
		width: 100%;
		flex-direction: column-reverse;
		align-items: center;
		position: fixed;
		background: #fff;
		bottom:0;
		.el-btn{
			width: 90%;
			height: 50px;
			line-height: 50px;
			text-align: center;
			color: #fff;
			font-size:18px;
			background: url('../../assets/img/button/bg_bt.png')no-repeat center;
			background-size: 100%;
			border-radius: 200px;
		}
	}
	.footer{
		padding: 15px;
    	align-items: center;
		flex-direction: row;
		justify-content: center;
		background: rgb(247, 248, 250);
		.t{
			font-size: 13px;
			font-weight: 400;
			color: #06121e;
		}
		.link{
			font-size: 13px;
			font-weight: 400;
			color: #1c96f6;
			text-decoration: underline;
			margin-left: 5px;
		}
	}
}

</style>
